var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo"},[_c('div',{staticClass:"page",staticStyle:{"padding":"20px"}},[_c('van-button',{staticClass:"test",attrs:{"type":"primary","block":""},on:{"click":_vm.gotoAuth}},[_vm._v("企业微信授权测试")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }